import { useEffect } from "react";
import Cancelimg from "../../assets/img/cancel-01.svg";

const PermissoWidget = ({ widgetUrl, onClose, onSuccess, onError }) => {
  useEffect(() => {
    const handleMessage = (event) => {
      const allowedOrigin =
        process.env.REACT_APP_URL_NAME === "localhost:3000"
          ? [
              "https://widget.sandbox.bankflip.io",
              "https://widget.sandbox.permisso.io",
            ]
          : ["https://widget.bankflip.io", "https://widget.permisso.io"];

      if (!allowedOrigin.includes(event?.origin)) {
        return;
      }

      const data = event?.data;

      if (data?.name === "user_requested_closure") {
        onSuccess && onSuccess(data);
        onClose && onClose();
      } else if (
        ["session_cancelled", "token_expired", "session_expired"].includes(
          data?.name
        )
      ) {
        onError && onError(data);
        onClose && onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onClose, onSuccess, onError]);

  return (
    <div className="popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen">
      <div className="position-relative claveModal required-doc-popup h-[90%] bg-white rounded-xl overflow-hidden shadow-lg">
        <iframe
          src={widgetUrl}
          style={{ height: "70vh", width: "100%" }}
          title="Permisso Widget"
          allow="camera; microphone; clipboard-read; clipboard-write"
        />
        <div className="cursor-pointer" onClick={() => onClose && onClose()}>
          <img src={Cancelimg} alt="icon" className="canceicon topRightIcon" />
        </div>
      </div>
    </div>
  );
};

export default PermissoWidget;
